"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIMITATIONS = exports.stackMessageRegex = exports.DEFAULT_CHECK_INTERVAL = void 0;
// 默认一分钟检测上报
exports.DEFAULT_CHECK_INTERVAL = 60000;
exports.stackMessageRegex = {
    chrome: /^(.*)\n\s+(at)/,
    safari: /^(.*)\/<@/
};
exports.LIMITATIONS = {
    REPORT_TRANSACTION_LIMIT: 300,
    REPORT_BULK_TRIM_LIMIT: 1200,
    REPORT_BULK_ABORT_LIMIT: 100
};
